/*
# -----------------------------------------------------------------------------
#	Project: HSE Genius®
#	Client ID: 834215
#	Registration Code: IT-2025-ZR319-MQ744
#	Author: KaimakiWeb
#	Website: https://kaimakiweb.com
#	Copyright (c) 2024-2026 Kaimaki Web. All rights reserved.
#
#	This software and its source code are the property of KaimakiWeb.
#	Unauthorized copying, modification, distribution, or use of this software,
#	via any medium, is strictly prohibited unless prior written permission
#	is obtained from KaimakiWeb.
# -----------------------------------------------------------------------------
*/

export const selectAuthUser = (state) => state.auth.authData;

export const selectCompany = (state) => state.auth.company?.[0] ?? state.auth.company ?? null;

export const selectCounts = (state) => state.auth.counts;
export const selectHp = (state) => state.auth.hp;

export const selectSuccessSnackbar = (state) => state.ui.successSnackbar;
export const selectErrorSnackbar = (state) => state.ui.errorSnackbar;
export const selectInfoSnackbar = (state) => state.ui.infoSnackbar;
export const selectValidationState = (state) => state.ui.isValidationActive;
